<script setup name="TvbHomeColumns">
import { reactive, inject, onServerPrefetch, onMounted } from 'vue'
import { getHomeLayout } from './../../../../api/home'
import TvbHomeSmallBanner from './../SmallBanner/index.vue'
import TvbHomeColumnsNews from './../News/index.vue'
import TvbHomeMytvSuper from './../MytvSuper/index.vue'
import TvbHomeMpm from './../Mpm/index.vue'
import TvbHomeEpg from './../Epg/index.vue'

const size = inject('size')

const layout = reactive({
  list: []
})

const componentsMap = {
  1: TvbHomeSmallBanner,
  2: TvbHomeColumnsNews,
  3: TvbHomeColumnsNews,
  4: TvbHomeMytvSuper,
  10: TvbHomeColumnsNews,
  11: TvbHomeMpm,
  12: TvbHomeEpg,
  13: TvbHomeColumnsNews
}

const fetchHomeLayout = async () => {
  return new Promise((resolve, reject) => {
    getHomeLayout()
      .then(({ data }) => {
        layout.list = data.list
        resolve()
      })
      .catch((error) => {
        reject(error)
      })
  })
}

onServerPrefetch(fetchHomeLayout)
onMounted(fetchHomeLayout)
</script>

<template>
  <div class="tvb-home-columns" :class="[size]">
    <template v-for="(item, index) in layout.list" :key="index">
      <component
        :is="componentsMap[item.type]"
        :info="item"
        :is-video="item.type === 13"
        :link-target="[2, 3, 4].includes(item.type) ? 2 : 1"
      />
      <tvb-ads
        :ad-type="['s', 'xs'].includes(size) ? 'bn' : 'sb'"
        :position="6"
        :style="{ marginTop: ['s', 'xs'].includes(size) ? '32px' : '56px' }"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.tvb-home-columns {
  --tvb-home-columns-margin-top: 32px;
  &.xl {
    --tvb-home-columns-margin-top: 40px;
  }

  > * {
    margin-top: var(--tvb-home-columns-margin-top) !important;
    &:first-child {
      margin-top: 0 !important;
    }
  }
  &.s,
  &.xs {
    > * {
      &:first-child {
        margin-top: 12px !important;
      }
    }
  }
}
</style>
